import { generatePath, useParams } from "react-router-dom";
import { useTranslation } from "react-i18next";
import { pathname } from "#src/config/pathname";
import { BreadcrumbV2 } from "#src/commonV2/Breadcrumb";
import { EndpointDlpDataLabelManageSection } from "#src/components/endpoint/dlp/dataLabeling/labelManage";
import { EndpointDlpDataLabelSensitivityChangeSection } from "#src/components/endpoint/dlp/dataLabeling/sensitivityChange";

export const DlpDataLabeling = () => {
  const { t } = useTranslation("endpoint", { keyPrefix: "dlp.dataLabeling" });

  const { workspaceId } = useParams<"workspaceId">();

  if (!workspaceId) {
    return null;
  }

  // --------------- STATES ---------------

  // --------------- HOOKS ---------------

  // --------------- METHODS ---------------

  // --------------- COMPUTED ---------------

  // --------------- EFFECTS ---------------

  // --------------- RENDER ---------------

  return (
    <>
      <div className="pt-5 pb-6 flex flex-col gap-5 min-h-screen">
        {/* Header (Breadcrumb + title) */}
        <div className="px-8 flex flex-col gap-4">
          <BreadcrumbV2
            levels={[
              {
                name: t("breadcrumb.levels.endpoint"),
                path: generatePath(pathname.ENDPOINT_OVERVIEW, { workspaceId }),
              },
            ]}
            currentPage={{
              name: t("breadcrumb.current.dataLossPrevention"),
              tab: t("breadcrumb.current.dataLabeling"),
            }}
          />
          <span className="text-display-xs font-semibold text-gray-v2-900">
            {t("title")}
          </span>
        </div>
        {/* Header (Breadcrumb + title) end */}

        {/* Content */}
        <div className="px-8 pb-12 flex flex-col gap-5">
          <EndpointDlpDataLabelManageSection workspaceId={workspaceId} />
          {/* This section is not ready to be shown */}
          {/* <SectionCard
            header={
              <div className="flex items-center gap-2">
                <File06 className="h-5 w-5 min-w-5 text-gray-v2" />
                {t("dataProtectionPolicy.title")}
              </div>
            }
          >
            <TableV2<any>
              data={[{ id: "ok" }]}
              getRowKey={(item) => item.id}
              columns={[
                {
                  title: t("dataProtectionPolicy.headers.policyName"),
                  render: () => "???",
                  gridTemplateValue: "3fr",
                },
                {
                  title: t("dataProtectionPolicy.headers.applyForSensitivity"),
                  render: () => "???",
                  gridTemplateValue: "2fr",
                },
                {
                  title: t("dataProtectionPolicy.headers.applyForContentTag"),
                  render: () => "???",
                  gridTemplateValue: "2fr",
                },
                {
                  title: t("dataProtectionPolicy.headers.status"),
                  render: () => <Switch />,
                  gridTemplateValue: "8rem",
                },
              ]}
            />
          </SectionCard> */}
          <EndpointDlpDataLabelSensitivityChangeSection
            workspaceId={workspaceId}
          />
        </div>
        {/* Content end */}
      </div>
    </>
  );
};
